import React, {Component, Fragment} from 'react';
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";
import Collapsible from "react-collapsible";
import {collapsibleSettings} from "../../helpers/Helpers";
import ImageField from "./ImageField";
import InputWrap from "./InputWrap";
import SelectField from './SelectField';
import CONSTANTS from '../../config/constants';

class ImageFieldWithOpacity extends Component {
    onChangeOpacity = (opacity) => {
        const {input} = this.props;

        input.onChange({
            ...input.value,
            opacity
        });
    };

    onChangeImage = (image) => {
        const {input} = this.props;

        input.onChange({
            ...input.value,
            image: image
        });
    };

    render() {
        const {
            input,
            label,
            omitCollapsible,
            expanded
        } = this.props;
        const defaultValue = 100;
        const content = (
            <InputWrap {...this.props} label={null}>
                <ImageField
                    {...this.props}
                    title={'Image'}
                    input={{
                        value: input.value.image ? input.value.image : '',
                        onChange: this.onChangeImage
                    }}
                    omitCollapsible={true}
                />
                <br/>
                <SelectField
                    label={'Opacity'}
                    defaultValue={input.value.opacity ? CONSTANTS.OPACITY_DROPDOWN.find((a) => a.id === input.value.opacity) : CONSTANTS.OPACITY_DROPDOWN.find((a) => a.id === defaultValue)}
                    omitCollapsible={true}
                    afterOnChange={(opacity) => {
                        this.onChangeOpacity(opacity);
                    }}
                    items={CONSTANTS.OPACITY_DROPDOWN}
                    classes="field--opacity"
                />
            </InputWrap>
        );

        return (
            <Fragment>
                {omitCollapsible ? (
                    <div>{content}</div>
                ) : (
                    <Collapsible
                        {...collapsibleSettings}
                        trigger={<label className={classNamesPrefixed({"trigger__label": true})}>{label ? label : 'Image'}</label>}
                        open={expanded}
                    >
                        {content}
                    </Collapsible>
                )}
            </Fragment>
        );
    };
}

export default ImageFieldWithOpacity;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/ImageFieldWithOpacity.js